<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="4">
                  <BaseSelect
                    :options="productSelect.options"
                    :data="productSelect.data"
                    ref="productSelect">
                  </BaseSelect>
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                  />
                  <BaseInput
                    :options="contentInput.options"
                    :data="contentInput.data"
                  />
                  <BaseSelect
                    :options="isActiveSelect.options"
                    :data="isActiveSelect.data"
                    ref="isActive"
                  >
                  </BaseSelect>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-plus"></i> Thêm mới
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.push('/products-management/managed-specification')"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "SpecificationAdd",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      productSelect: {
        options: {
          'keyField': 'id',
          'valueField': 'code',
          label: "Danh mục",
          selectAllText: 'Chọn sản phẩm'
        },
        data: {
          model: '',
          name: 'productId',
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.productSelect.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      codeInput: {
        options: {
          label: "Mã thông số *",
          placeholder: "Mã thông số",
          type: "text",
          maxLength : 45
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã thông số không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên thông số *",
          placeholder: "Tên thông số",
          type: "text",
          maxLength : 128
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên thông số không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      contentInput: {
        options: {
          label: "Nội dung thông số *",
          placeholder: "Nội dung thông số",
          type: "text",
          maxLength : 256
        },
        data: {
          name: "content",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.contentInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Nội dung thông số không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: '1'
        }
      }
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/specification/createSpecification",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Thêm mới thông số kỹ thuật thành công"});
            that.$router.push(`/products-management/managed-specification/${response.data.data.id}`)
            // that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadDataProduct: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/product/listProductActive",
        successCallback: function (response) {
          that.productSelect.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadDataProduct();
  },
  watch: {}
};
</script>
